<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div :class="`modal-dialog ${size}`" role="document">
      <div class="modal-content">
        <div v-if="title != ''" class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ title }}
          </h5>
          <button v-if="close_header" type="button" class="close" aria-label="Close" @click.prevent="close">
						<span aria-hidden="true">×</span>
					</button>
        </div>
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    size: { default: 'modal-lg', type: String },
    close_header: { default: false, type: Boolean },
    close_modal: { default: false, type: Boolean }
  },
  methods: {
    close () {
      this.$emit('close')
      if (!this.close_modal) window.$(`#${this.id}`).modal('hide')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Modal.vue